module.exports = __webpack_public_path__ + "static/media/link.d4a5ebe6.svg";